/*!
 * Productzoeker - extra (Islamboekhandel.nl)
 * Zet de knop 'Opnieuw beginnen' rechtsboven bij elke vraag.
 * De knop gebruikt data-pz-restart, dus productzoeker.js handelt de klik af.
 */
(function () {
  'use strict';
  var BTN = '<button type="button" class="pz-btn pz-btn--ghost pz-restart-top" data-pz-restart>' +
    '<span aria-hidden="true">↺</span> Opnieuw beginnen</button>';
  function add(root) {
    root.querySelectorAll('.pz-step:not(.pz-start)').forEach(function (step) {
      if (step.querySelector('.pz-restart-top')) return;
      step.classList.add('pz-step--restart');
      step.insertAdjacentHTML('afterbegin', BTN);
    });
  }
  function watch(el) {
    if (el.__pzExtra) return;
    el.__pzExtra = true;
    add(el);
    if (window.MutationObserver) new MutationObserver(function () { add(el); }).observe(el, { childList: true, subtree: true });
  }
  function boot() { document.querySelectorAll('[data-pz]').forEach(watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();